/** The loading scene: on the road between places. A light zheng tune over rippling arpeggios, a bell. */
import { arp, drone } from '../compose';
import { registerTrack } from '../registry';

const A = `@mf 5_ 6_ 1' 2'_ 3'_ 2' | 1'_ 6_ 5 6/- | 3_ 5_ 6_ 1'_ 2' 1'_ 6_ | 5-~-- |
  6_ 1'_ 2' 3'. 5'_ | 3'_ 2'_ 1' 2'\\- | 3'_ 2'_ 1'_ 6_ 5_ 6_ 1'_ 2'_ | 1'g---`;
const ROOTS_A = `1, 6,, 5,, 1, 6,, 2, 5,, 1,`;

const B = `@mp 6G. 5_ 3 5 | 6_ 1'_ 6_ 5_ 3^- | 2. 3_ 5 3 | 2%--- |
  3_ 5_ 6_ 1'_ 2' 3' | 2'_ 1'_ 6 5~- | 6_ 5_ 3_ 2_ 1 2 | 1-~--`;
const ROOTS_B = `6,, 6,, 2, 5,, 3, 6,, 2, 1,`;

registerTrack({
  id: 'loading',
  order: 2,
  title: 'ระหว่างทาง',
  mood: 'เบาสบาย เดินหน้า รอคอย',
  use: 'ฉากโหลด / เดินทางข้ามแผนที่',
  key: 'G',
  mode: 'gong',
  bpm: 84,
  meter: 4,
  seed: 202,
  gain: 1.35,
  parts: {
    zheng: { inst: 'zheng', pan: 0.1 },
    harp: { inst: 'zheng', gain: 0.45, pan: -0.25 },
    pad: { inst: 'pad', gain: 0.6 },
    bells: { inst: 'perc', gain: 0.18, pan: 0.3, reverb: 0.5 },
  },
  sections: {
    A: {
      bars: 8,
      parts: {
        zheng: A,
        harp: arp(ROOTS_A, [0, 3, 5, 6, 7, 6, 5, 3]),
        pad: drone(ROOTS_A, 4),
        bells: `h--- | 0--- | 0--- | 0--- | 0--- | 0--- | 0--- | h---`,
      },
    },
    B: {
      bars: 8,
      parts: {
        zheng: B,
        harp: arp(ROOTS_B, [0, null, 3, 5, null, 3, 5, 3]),
        pad: drone(ROOTS_B, 4),
        bells: `0--- | 0--- | 0--- | h--- | 0--- | 0--- | 0--- | 0---`,
      },
    },
    A2: {
      bars: 8,
      parts: {
        zheng: A,
        harp: arp(ROOTS_A, [0, 2, 3, 5, 3, 5, 6, 5]),
        pad: drone(ROOTS_A, 4),
        bells: `h--- | 0--- | 0--- | h--- | 0--- | 0--- | 0--- | h---`,
      },
    },
  },
  form: ['A', 'B', 'A2'],
  loop: true,
});
